import React from 'react';
import Col from 'react-bootstrap/Col';
import './shopping-cart-header.scss';
function ShoppingCartHeader({ text, className = false }) {
  return (
    <Col
      xs={12}
      className={`text-content-container review-shopping ${
        className ? className : ''
      }`}>
      <div className="text-content background transparent">
        <div className="inner-wrapper  trinity-container">
          <p className="m-0 review-shopping-header">{text}</p>
        </div>
      </div>
    </Col>
  );
}

export default ShoppingCartHeader;
